import { render, staticRenderFns } from "./v-tag.vue?vue&type=template&id=480d2d67&"
import script from "./v-tag.vue?vue&type=script&lang=js&"
export * from "./v-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports